import type { QueryClient } from "@tanstack/react-query";
import { familyPaymentAllocationQueryKey } from "@/features/balance/utils/family-payment-allocation";
import { createAuthenticatedApi } from "@/lib/utils";
import { toRequestCurrency } from "@/lib/utils/currency";
import { studioTodayYmd } from "@/lib/utils/date/studio-clock";
import { PaymentApi } from "@/openapi/generated";
import { ResponseError } from "@/openapi/generated/runtime";

export async function prefetchFamilyPaymentAllocationGet(
  userId: number,
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number,
  currency: string | null | undefined,
  timeZone?: string | null,
) {
  const requestCurrency = toRequestCurrency(currency);
  const billingDateYmd = studioTodayYmd(new Date(), timeZone);
  const service = createAuthenticatedApi(PaymentApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: familyPaymentAllocationQueryKey(
      userId,
      billingDateYmd,
      requestCurrency,
    ),
    queryFn: async () => {
      try {
        const rows = await service.apiPaymentsFamilyPaymentAllocationGet({
          userId,
          currency: requestCurrency,
          billingDate: billingDateYmd,
          xTenantID: tenantId,
        });
        return rows ?? [];
      } catch (error) {
        if (
          error instanceof ResponseError &&
          (error.response.status === 404 || error.response.status === 403)
        ) {
          return [];
        }
        console.error("[BalancePage SSR] family payment allocation failed", {
          userId,
          error,
        });
        return [];
      }
    },
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}
